import React, { useState } from 'react';
import './Login.css';
import DetoxaLogo from '../../assets/logo.png';
import axios from 'axios';
import Recaptcha from 'react-recaptcha';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Link } from 'react-router-dom';
import { setUsername, setBearerToken } from '../../redux/admin/userActions.js';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => ({
	root: {
		'& > *': {
			margin: theme.spacing(1),
			width: '40ch',
		},
	},
}));

const Login = (props) => {
	const dispatch = useDispatch();
	const registerpass = useSelector((state) => state.user.password);

	const classes = useStyles();
	const { phoneNumber, setPhoneNumber, changeStep, nextStep } = props;
	const [loginwthpass, setloginwthpass] = useState(false);
	const [isVerified, setIsVerified] = useState(false);
	const [credentialPhone, setCredentialPhone] = useState('');
	const [credentialPassword, setCredentialPassword] = useState('');
	const [email,setemail]=useState("");
	const handleChange = (event) => {
		setPhoneNumber(event.target.value);
	};

	const handlecred = () => {
		setloginwthpass(!loginwthpass);
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		if (isVerified) {
			axios
				.post('https://detoxa-dev.herokuapp.com/auth/user/login/passwordless', {
					phone: phoneNumber,
				})
				.then((res) => {
					console.log(res.data);
					dispatch(setUsername(res.data.name));
					dispatch(setBearerToken(res.data.token));
					changeStep(nextStep);
				})
				.catch((err) => {
					
					console.log(err);
					alert('Sorry no account found Please register!');
					setPhoneNumber('');
				});
		} else alert('Please verify that you are a human');
	};
	const verifyCallback = (response) => {
		if (response) setIsVerified(true);
	};
	const handleCredentialSubmit = (event) => {
		event.preventDefault();
		if (isVerified) {
			axios
				.post('https://detoxa-dev.herokuapp.com/auth/user/login/withpassword', {
					email: email,
					password: credentialPassword,
				})
				.then((res) => {
					console.log(res.data);
					dispatch(setUsername(res.data.name));
					alert('Enjoy you are logged in :)');
					changeStep(4);
				})
				.catch((err) => {
					alert('Wrong credentials entered !');
					console.log(err);
				});
		} else alert('Please verify that you are a human :) ');
	};
	return (
		<div className='Login'>
			<img src={DetoxaLogo} alt='Detoxa Logo' />

			{loginwthpass ? (
				<form onSubmit={handleCredentialSubmit}>
					<h6>Login in with credentials</h6>
					<div className={classes.root}>
						<TextField
							id='outlined-basic'
							label='Enter your email'
							variant='outlined'
							required
							value={email}
							onChange={(event) => {
								setemail(event.target.value);
							}}
							className='browser-default'
						/>
						<TextField
							id='outlined-basic'
							label='Enter your password'
							variant='outlined'
							required
							type='password'
							value={credentialPassword}
							onChange={(event) => {
								setCredentialPassword(event.target.value);
							}}
							className='browser-default'
						/>
					</div>
					<button>Login</button>
				</form>
			) : (
				<form onSubmit={handleSubmit}>
					<h6>Let's get started</h6>
					<div className={classes.root}>
						<TextField
							id='outlined-basic'
							label='mobile number'
							variant='outlined'
							required
							value={phoneNumber}
							onChange={handleChange}
							className='browser-default'
						/>
						<p className='helper-text'>Please enter a mobile number to proceed</p>
						<p
							className='helper-text'
							onClick={handlecred}
							style={{ cursor: 'pointer', color: 'red' }}
						>
							Login with credentials?
						</p>
					</div>
					<button>Proceed to login</button>
				</form>
			)}
			<Recaptcha
				sitekey='6LcAzs8aAAAAAJw8O8qfrcfM2rlQgH-GBgyvdBCT'
				render='explicit'
				verifyCallback={verifyCallback}
				onloadCallback={() => console.log('Recaptcha has loaded')}
			/>
		</div>
	);
};

export default Login;
